var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInviteGroupChatWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icInviteGroupChatWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Receive",
    transform: "translate(-61.000000, -549.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(50.000000, 538.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icInviteGroupChatWhite",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8355903,14.7023003 C22.9829861,11.6894097 22.6547309,7.56158854 19.721658,4.87274306 C18.3815104,3.64422743 16.6730469,2.87942708 14.8275174,2.66584201 C14.8160156,2.65169271 14.8042535,2.63767361 14.7913628,2.62426215 C13.1858507,0.956510417 10.8792535,0 8.46302083,0 C3.86497396,0 0,3.42591146 0,7.8125 C0,9.35047743 0.477734375,10.8248264 1.38524306,12.0981337 L0.117491319,16.0784288 C0.0378038194,16.3286024 0.116189236,16.6020833 0.316232639,16.772092 C0.516623264,16.9424045 0.799305556,16.9751302 1.0328559,16.8563368 L4.88819444,14.8959635 C5.67994792,15.2368924 6.51953125,15.4605903 7.38897569,15.5623698 C9.06614583,17.3260851 11.3851997,18.2291667 13.7578125,18.2291667 C14.9911458,18.2291667 16.2200087,17.9778212 17.3324653,17.5000868 L21.1879774,19.4605469 C21.2813368,19.5080295 21.3824219,19.53125 21.4828993,19.53125 C21.9222656,19.53125 22.2372396,19.1030816 22.103342,18.6825955 L20.8355903,14.7023003 Z M5.15095486,13.5859809 C4.96861979,13.4993924 4.75651042,13.5022569 4.5766059,13.59375 L1.83064236,14.9900174 L2.72734375,12.1746528 C2.79262153,11.9696615 2.75247396,11.7457031 2.62000868,11.5762153 C1.7577691,10.4724826 1.30199653,9.17105035 1.30199653,7.8125 C1.30199653,4.22265625 4.51440972,1.30208333 8.46302083,1.30208333 C10.053125,1.30208333 11.5838976,1.78381076 12.8256076,2.65130208 C8.64383681,3.07178819 5.29479167,6.33802083 5.29479167,10.4166667 C5.29479167,11.6852431 5.61996528,12.9065104 6.23302951,14.0006944 C5.86184896,13.8901476 5.50034722,13.7519097 5.15095486,13.5859809 L5.15095486,13.5859809 Z M17.6442274,16.1978733 C17.4669271,16.1077257 17.2546441,16.1023003 17.0698785,16.1901476 C16.0549045,16.6722656 14.9096354,16.9270833 13.7578125,16.9270833 C9.80920139,16.9270833 6.59678819,14.0065104 6.59678819,10.4166667 C6.59678819,6.82682292 9.80920139,3.90625 13.7578125,3.90625 C17.7064236,3.90625 20.9188368,6.82682292 20.9188368,10.4166667 C20.9188368,11.775217 20.4630642,13.0766493 19.6007813,14.1803385 C19.4683594,14.3498264 19.4282118,14.5737847 19.4934462,14.778776 L20.3901476,17.5941406 L17.6442274,16.1978733 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.1104167,
    cy: 10.4166667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.7144531,
    cy: 10.4166667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.3184462,
    cy: 10.4166667,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInviteGroupChatWhite);
export default __webpack_public_path__ + "static/media/icInviteGroupChatWhite.a4d12713782e99c47f6faaebca109e8e.svg";
export { ForwardRef as ReactComponent };